// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Q68i","importantInfo":"styles_importantInfo__3aVbS"};